/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Selection_Disabled_TitleInputs */

const en_audio_description_export_selection_disabled_title = /** @type {(inputs: Audio_Description_Export_Selection_Disabled_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Selection is disabled when Extended AD is enabled`)
};

const fr_audio_description_export_selection_disabled_title = /** @type {(inputs: Audio_Description_Export_Selection_Disabled_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La sélection d'événements est désactivée lorsque l'AD étendue est activée`)
};

const de_audio_description_export_selection_disabled_title = /** @type {(inputs: Audio_Description_Export_Selection_Disabled_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ereignisauswahl ist deaktiviert, wenn Extended AD aktiviert ist.`)
};

const it_audio_description_export_selection_disabled_title = /** @type {(inputs: Audio_Description_Export_Selection_Disabled_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La selezione degli eventi è disabilitata quando è abilitato l'AD esteso`)
};

const ru_audio_description_export_selection_disabled_title = /** @type {(inputs: Audio_Description_Export_Selection_Disabled_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Функция выбора событий отключена при включении расширенной функции Active Directory.`)
};

const es_audio_description_export_selection_disabled_title = /** @type {(inputs: Audio_Description_Export_Selection_Disabled_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La selección de eventos está deshabilitada cuando AD extendido está habilitado`)
};

const zh_cn2_audio_description_export_selection_disabled_title = /** @type {(inputs: Audio_Description_Export_Selection_Disabled_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用扩展 AD 后，事件选择功能将被禁用。`)
};

const ja_audio_description_export_selection_disabled_title = /** @type {(inputs: Audio_Description_Export_Selection_Disabled_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拡張ADが有効な場合、イベント選択は無効になります`)
};

const hi_audio_description_export_selection_disabled_title = /** @type {(inputs: Audio_Description_Export_Selection_Disabled_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक्सटेंडेड AD सक्षम होने पर इवेंट चयन अक्षम हो जाता है।`)
};

const pt_pt2_audio_description_export_selection_disabled_title = /** @type {(inputs: Audio_Description_Export_Selection_Disabled_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A seleção de eventos é desativada quando o Active Directory estendido está ativado.`)
};

/**
* | output |
* | --- |
* | "Event Selection is disabled when Extended AD is enabled" |
*
* @param {Audio_Description_Export_Selection_Disabled_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_selection_disabled_title = /** @type {((inputs?: Audio_Description_Export_Selection_Disabled_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Selection_Disabled_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_selection_disabled_title(inputs)
	if (locale === "de") return de_audio_description_export_selection_disabled_title(inputs)
	if (locale === "it") return it_audio_description_export_selection_disabled_title(inputs)
	if (locale === "ru") return ru_audio_description_export_selection_disabled_title(inputs)
	if (locale === "es") return es_audio_description_export_selection_disabled_title(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_selection_disabled_title(inputs)
	if (locale === "ja") return ja_audio_description_export_selection_disabled_title(inputs)
	if (locale === "hi") return hi_audio_description_export_selection_disabled_title(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_selection_disabled_title(inputs)
	return en_audio_description_export_selection_disabled_title(inputs)
});